import { getToken, removeToken, setToken } from '@/utils/auth'
import { setRegCode, setWxCode } from '@/utils/cookie'
import { loginByMobile, logout, register } from '@/api/auth'
import { fetchMyInfo, saveSign } from '@/api/my'
import { fetchWxAuth } from '@/api/wx'
import { fetchSetting } from '../../api/setting'
import { getPopupList, setPopupList } from '../../utils/storage'

const user = {
  state: {
    token: getToken(),
    user: null,
    surveyCode: null,
    popupSetting: -1,
    popupViewList: getPopupList(),
    showPopup: false
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken(token)
    },
    DEL_TOKEN: (state) => {
      state.token = ''
      state.user = null
      removeToken()
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_SIGN: (state) => {
      state.user.sign = 1
    },
    SET_SURVEY_CODE: (state, code) => {
      state.surveyCode = code.code
    },
    SET_POPUP_SETTING: (state, setting) => {
      state.popupSetting = setting
    },
    SET_SHOW_POPUP: (state, showPopup) => {
      state.showPopup = showPopup
    },
    ADD_POPUP_VIEW_LIST: (state, image) => {
      state.popupViewList.push(
        { image: image, timestamp: new Date().getTime() })
      setPopupList(state.popupViewList)
    },
    SET_SMS_VERIFY_FLAG: (state) => {
      state.user.sms_verify_flag = 1
    }
  },

  actions: {
    async GetWxUserInfo({ commit }, query) {
      try {
        const { data } = await fetchWxAuth(query)
        if (data.message === 'ok') {
          if (data.rst.token) {
            commit('SET_TOKEN', data.rst.token)
          } else if (data.rst.wx_code) {
            setWxCode(data.rst.wx_code)
          }
        }
        return data
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async LoginByMobile({ commit }, loginForm) {
      try {
        const { data } = await loginByMobile(loginForm)
        if (data.message === 'ok') {
          if (data.rst.token) { // 返回token,表示该手机号码对应的用户已注册
            commit('SET_TOKEN', data.rst.token)
          } else {  // 保存注册用的code，用于注册时带上
            setRegCode(data.rst.reg_code)
          }
        }
        return data
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async Register({ commit }, regForm) {
      try {
        const { data } = await register(regForm)
        if (data.message === 'ok' && data.rst.token) {
          commit('SET_TOKEN', data.rst.token)
        }
        return data
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async GetUserInfo({ commit }) {
      try {
        const rsp = await fetchMyInfo()
        if (rsp.data.message === 'ok') {
          rsp.data.rst.avatar = rsp.data.rst.avatar + '?version=' +
            new Date().valueOf()
          commit('SET_USER', rsp.data.rst)
        }
        return Promise.resolve(rsp)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async SaveSign({ commit }) {
      try {
        const { data } = await saveSign()
        if (data.message === 'ok') {
          commit('SET_SIGN')
        }
        return data
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async GetSetting({ commit }) {
      try {
        const { data } = await fetchSetting()
        if (data.message === 'ok') {
          const popupViewList = getPopupList()
          if (data.rst.popup.image && data.rst.popup.time.start <=
            new Date().getTime() / 1000 &&
            data.rst.popup.time.end > new Date().getTime() / 1000) {
            let historyPopup = null
            for (const popup of popupViewList) {
              if (popup.image === data.rst.popup.image) {
                historyPopup = popup
              }
            }
            if (historyPopup) {
              const currTime = new Date().getTime()
              if (currTime - historyPopup.timestamp > 60 * 60 * 24 * 1000) {
                commit('SET_POPUP_SETTING', data.rst.popup)
                commit('SET_SHOW_POPUP', true)
              }
            } else {
              commit('SET_POPUP_SETTING', data.rst.popup)
              commit('SET_SHOW_POPUP', true)
            }
          } else {
            commit('SET_POPUP_SETTING', null)
            commit('SET_SHOW_POPUP', false)
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    AddPopupViewList({ commit }, image) {
      commit('ADD_POPUP_VIEW_LIST', image)
    },
    Logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('DEL_TOKEN')
          resolve()
        }).catch(error => {
          removeToken()
          reject(error)
        })
      })
    },

    FedLogOut({ commit }) {
      commit('DEL_TOKEN')
      setTimeout(function() {
        return new Promise(resolve => {
          resolve()
        })
      }, 1500)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js